function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" className={(styles["wwp3-icon"] || "wwp3-icon") + " " + (styles["wwp3-icon--filter"] || "wwp3-icon--filter")} {...props}><path d="M44 13.5c0 .828-.656 1.5-1.464 1.5H4.464C3.656 15 3 14.328 3 13.5S3.656 12 4.464 12h38.072c.808 0 1.464.672 1.464 1.5zM39.542 24H7.458C6.653 24 6 24.672 6 25.5S6.653 27 7.458 27h32.084c.805 0 1.458-.672 1.458-1.5s-.653-1.5-1.458-1.5zm-9.997 12h-13.09C15.65 36 15 36.672 15 37.5s.651 1.5 1.455 1.5h13.09C30.35 39 31 38.328 31 37.5s-.651-1.5-1.455-1.5z" /></svg>;
});


// WEBPACK FOOTER //
// src/assets/icons/filter.svg